export const masterConfigurationList = [
  'gender',
  'bloodGroup',
  'nationality',
  'translation',
  'trackerAttribute',
  'trackerEntities',
  'trackerDefaultLocation',
  'ptwRiskType',
  'ptwType',
  'timeZoneList',
  'reaDefaultTime',
  'zoneProperties',
  'zoneRiskType',
  'entityIconList',
  'genericFormData',
  'vehicleAttributes',
  'kba',
  'kbc',
  'fileSizeFormat',
  'blobRegistry',
  'alertSeverity',
  'alertAction',
  'alertCategory',
  'categoryNature',
  'unitOfMeasurement',
  'typ',
  'classType',
  'appsAndModels',
  'appType',
  'GADH',
  'SADH',
  'featureType',
  'menu',
  'attributeThreshold',
  'profileAttributeIcons',
  'tabStructure',
  'webNotification',
  'syncInfo',
  'cnpdestinations',
  'columnHeader',
  'tenantCategory',
  'userReportForm',
  'reportConfiguration',
  'pageLimits',
  'infoMessage',
  'cnpTimeline',
  'gaugeProperty',
  'cnpTruckConfig',
  'refreshTimeList',
  'tenantGenericConfig',
  'trlRulConfig',
  'entityFilters',
  'trlThresholds',
  'latencyThreshold',
  'devToolsStatistics',
  'entityFilter',
  'entityDeviceOnboardFormConfig',
  'widgetStatusColor',
  'dateTimeRanges',
  'stateDefinitions',
  'analyticsChartBuilderConfig',
  'ruleBuilderConfig',
  'customAnalyticsChartConfig',
  'bluePrint',
  'idmConfig',
  'catalogueConfig',
  'rcaList',
  'notReachableVehicles',
  'fileTypes',
  'imageTypes',
  'ioclDataConfig',
  'analyticsUseCases',
  'ioclMapping',
  'blueprintFieldMappings',
  'presetValues',
  'averageDailySales',
  'exportGenericConfig',
  'dtcPrediction',
  'playbackV2MapControlsList',
  'exportGenericConfig',
  'iceOptimizationSummaryConfigs',
  'exportGenericConfig',
  'activitiesMasterList',
  'batchDetails',
  'tfsStatusWidgets',
  'tfsCumulativeView',
  'tfsActivityTimeResolvers',
  'activitySpecificDrillDownApiCalls',
  'activityEventMappingConfig',
  'tooltipFieldsConfig',
  'streamAnomalyCodes',
  'anomalyPlot'
];
